import { createGlobalStyle } from "styled-components";

const HallwayStyles = createGlobalStyle`
  /* Styles only apply to hallway-embed inside Hallway.js */
  .hallway-instance hallway-embed::part(expanded) {
    max-height: 100%;
    max-width: 100%;
    overflow: hidden;
    bottom: 0;
    left: 0;
    position: relative;
  }

  .hallway-instance hallway-embed::part(minimized) {
    opacity: 0.6;
    transition: all 0.3s ease-in-out;
    width: 0px;
    top: 40%;
    left: 0px;
  }

  @media (max-width: 768px) {
    .hallway-instance hallway-embed {
      width: 100%;
      height: 100%;
      padding: 0;
      margin: 0;
    }
  }
  .hallway-instance-home hallway-embed::part(expanded) {
    max-height: 480px;
    max-width: 300px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    bottom: 8px;
    right: 8px;
    position: absolute;

    @media (max-width: 768px) {
      width: 100%;
      height: 100%;
      padding: 0;
      margin: 0;
      max-height: 380px;
      max-width: 350px;
      bottom: 4px;
      right: 4px;
    }
    @media (max-height: 768px) {
      width: 100%;
      height: 100%;
      padding: 0;
      margin: 0;
      max-height: 300px;
      max-width: 300px;
      bottom: 4px;
      right: 0px;
    }
  }

  .hallway-instance-home hallway-embed::part(minimized) {
    opacity: 0.6;
    transition: all 0.3s ease-in-out;
    right: 20px;
    bottom: 20px;
    width: 100%;
  }
`;

export default HallwayStyles;
